// Mock school events data for demonstration
export const mockSchoolEvents = [
  {
    id: 1,
    title: '開學典禮',
    description: '2024年第一學期開學典禮，歡迎所有同學回到學校。',
    date: '2024-01-15',
    startTime: '09:00',
    endTime: '10:30',
    location: '學校禮堂',
    category: '學校活動',
    priority: 'high',
    organizer: '教務處',
    participants: '全校師生',
    status: 'upcoming',
    registrationRequired: false,
    maxParticipants: null,
    currentParticipants: 0,
    attachments: ['開學典禮流程.pdf']
  },
  {
    id: 2,
    title: '家長會會議',
    description: '本學期第一次家長會，討論學校發展計劃和學生表現。',
    date: '2024-01-25',
    startTime: '14:00',
    endTime: '16:00',
    location: '學校禮堂',
    category: '家長活動',
    priority: 'high',
    organizer: '家長教師會',
    participants: '家長代表',
    status: 'upcoming',
    registrationRequired: true,
    maxParticipants: 100,
    currentParticipants: 45,
    attachments: ['家長會議程.pdf', '學校發展報告.pdf']
  },
  {
    id: 3,
    title: '課外活動展覽',
    description: '展示本學期各種課外活動成果，包括音樂、美術、體育等表演。',
    date: '2024-02-10',
    startTime: '14:00',
    endTime: '17:00',
    location: '學校操場',
    category: '課外活動',
    priority: 'medium',
    organizer: '課外活動組',
    participants: '全校師生及家長',
    status: 'upcoming',
    registrationRequired: false,
    maxParticipants: null,
    currentParticipants: 0,
    attachments: ['活動流程.pdf']
  },
  {
    id: 4,
    title: '環保回收日',
    description: '每週環保回收活動，收集可回收物品，培養環保意識。',
    date: '2024-01-19',
    startTime: '08:00',
    endTime: '16:00',
    location: '學校門口',
    category: '環保活動',
    priority: 'low',
    organizer: '環保組',
    participants: '全校師生',
    status: 'upcoming',
    registrationRequired: false,
    maxParticipants: null,
    currentParticipants: 0,
    attachments: ['回收指南.pdf']
  },
  {
    id: 5,
    title: '圖書館讀書會',
    description: '每月讀書會，分享閱讀心得，培養閱讀興趣。',
    date: '2024-01-30',
    startTime: '15:00',
    endTime: '16:30',
    location: '圖書館',
    category: '學術活動',
    priority: 'medium',
    organizer: '圖書館',
    participants: '中高年級學生',
    status: 'upcoming',
    registrationRequired: true,
    maxParticipants: 30,
    currentParticipants: 18,
    attachments: ['讀書會書單.pdf']
  },
  {
    id: 6,
    title: '運動會',
    description: '年度運動會，包括田徑、球類等各種運動項目。',
    date: '2024-03-15',
    startTime: '08:00',
    endTime: '17:00',
    location: '學校操場',
    category: '體育活動',
    priority: 'high',
    organizer: '體育組',
    participants: '全校師生',
    status: 'upcoming',
    registrationRequired: true,
    maxParticipants: 200,
    currentParticipants: 156,
    attachments: ['運動會項目表.pdf', '比賽規則.pdf']
  },
  {
    id: 7,
    title: '音樂會',
    description: '學生音樂表演，展示音樂課和課外活動的學習成果。',
    date: '2024-02-28',
    startTime: '19:00',
    endTime: '21:00',
    location: '學校禮堂',
    category: '藝術活動',
    priority: 'medium',
    organizer: '音樂組',
    participants: '音樂班學生及家長',
    status: 'upcoming',
    registrationRequired: true,
    maxParticipants: 150,
    currentParticipants: 89,
    attachments: ['音樂會節目表.pdf']
  },
  {
    id: 8,
    title: '科學展覽',
    description: '學生科學作品展覽，展示科學實驗和創新項目。',
    date: '2024-03-20',
    startTime: '14:00',
    endTime: '17:00',
    location: '科學實驗室',
    category: '學術活動',
    priority: 'medium',
    organizer: '科學組',
    participants: '全校師生及家長',
    status: 'upcoming',
    registrationRequired: false,
    maxParticipants: null,
    currentParticipants: 0,
    attachments: ['展覽指南.pdf']
  }
];

// Helper function to get events by category
export const getEventsByCategory = (category) => {
  return mockSchoolEvents.filter(event => event.category === category);
};

// Helper function to get events by date
export const getEventsByDate = (date) => {
  return mockSchoolEvents.filter(event => event.date === date);
};

// Helper function to get upcoming events
export const getUpcomingEvents = () => {
  const today = new Date().toISOString().split('T')[0];
  return mockSchoolEvents.filter(event => event.date >= today);
};

// Helper function to get events by priority
export const getEventsByPriority = (priority) => {
  return mockSchoolEvents.filter(event => event.priority === priority);
};

// Helper function to get events requiring registration
export const getEventsRequiringRegistration = () => {
  return mockSchoolEvents.filter(event => event.registrationRequired);
};

// Helper function to get events by date range
export const getEventsByDateRange = (startDate, endDate) => {
  return mockSchoolEvents.filter(event => {
    return event.date >= startDate && event.date <= endDate;
  });
};
